import React from 'react'
import { Stack } from '@mui/material'
import { NumberField } from 'src/Libs/inputs/formik'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { UnitTypes } from 'src/Libs/types'
import { useApp } from 'src/Hooks'
import { useUserRoles } from 'src/Hooks/user'
import { CommonFieldNames, CommonFieldLabels } from '../settings'

interface Props {
  disabled?: boolean
}

const MaxChargePowerField: React.FC<Props> = ({ disabled = false }) => {
  const { t } = useCustomTranslation()
  const { isMobile: isDownSm } = useApp()
  const { currentRole } = useUserRoles()

  const readonly = currentRole !== 'INSTALLER'

  return (
    <Stack direction={isDownSm ? 'column' : 'row'} spacing={2}>
      <NumberField
        name={CommonFieldNames.maxChargePower}
        label={t(CommonFieldLabels.maxChargePower)}
        suffix={UnitTypes.watt}
        disabled={disabled}
        step={1}
        fullWidth={isDownSm}
      />
      <NumberField
        name={CommonFieldNames.upperCurrentLimit}
        label={t(CommonFieldLabels.upperCurrentLimit)}
        suffix={UnitTypes.ampere}
        disabled={readonly || disabled}
        fullWidth={isDownSm}
      />
    </Stack>
  )
}

export default MaxChargePowerField
